import { Plus, History, EllipsisVertical } from 'lucide-react';
import Menus from './Menus';
import { type AppSurface } from '../components/BottomNav';

interface Props {
  onHistoryClick: () => void;
  onNewConversation: () => void;
  onChangeSurface: (surface: AppSurface) => void;
}

export default function Header({
  onHistoryClick,
  onNewConversation,
  onChangeSurface,
}: Props) {
  return (
    <header className="border-b-ink/14 border-b">
      <Menus>
        <div className="container mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="bg-ink/50 text-surface-elevated flex h-11 w-11 items-center justify-center rounded-full">
              A
            </span>
            <div className="flex flex-col">
              <p className="font-bold">Agent name</p>
              <p className="text-xs">Context indicator</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button onClick={onNewConversation}>
              <Plus />
            </button>
            <button onClick={onHistoryClick}>
              <History />
            </button>
            <div>
              <Menus.Toggle id="skills">
                <EllipsisVertical />
              </Menus.Toggle>
              <Menus.List id="skills">
                <Menus.Button onClick={() => onChangeSurface('skills')}>
                  Skills
                </Menus.Button>
              </Menus.List>
            </div>
          </div>
        </div>
      </Menus>
    </header>
  );
}
